module.exports = __webpack_public_path__ + "static/media/profilepic-jin.ce7aed35.jpg";